import script from "./Clients.vue?vue&type=script&setup=true&lang=js"
export * from "./Clients.vue?vue&type=script&setup=true&lang=js"

import "./Clients.vue?vue&type=style&index=0&id=bf58e58c&lang=scss"

const __exports__ = script;

export default __exports__